import { AppShell } from "@/components/AppShell"
import { ErrorBoundary } from "@/components/ErrorBoundary"
import { Header } from "@/components/Header"
import { LoginScreen } from "@/components/LoginScreen"
import { Toaster } from "@/components/ui/sonner"
import { useIdentity } from "@/lib/identity"

function App() {
  const { isAuthenticated } = useIdentity()

  return (
    <ErrorBoundary>
      {isAuthenticated ? (
        <AppShell />
      ) : (
        <div className="flex h-screen flex-col">
          <Header />
          <LoginScreen />
        </div>
      )}
      <Toaster />
    </ErrorBoundary>
  )
}

export default App
